import { getBaseUrl, setBaseUrl, request, productionRequest, getHeaders } from './api/http';
import { authApi } from './api/auth';
import { metaSchemaMethodsApi } from './api/metaSchemaMethods';
import { genericTableOperationsApi } from './api/genericTableOperations';
import { responseEquipmentInventoryApi } from './api/responseEquipmentInventory';
import { transferHoseAndPipeTestingAttachmentsPdfApi } from './api/transferHoseAndPipeTestingAttachmentsPdf';
import { formsStatusesApi } from './api/formsStatuses';
import { companyModuleManagementApi } from './api/companyModuleManagement';
import { r9ModuleApi } from './api/r9Module';
import { complianceEnvironmentalAspectsApi } from './api/complianceEnvironmentalAspects';
import { userManagementApi } from './api/userManagement';
import { healthCheckApi } from './api/healthCheck';
import { complianceRecordsApi } from './api/complianceRecords';
import { customersCompaniesApi } from './api/customersCompanies';
import { dashboardApi } from './api/dashboard';
import { complianceMapApi } from './api/complianceMap';
import { facilitiesSitesApi } from './api/facilitiesSites';
import { raciAssignmentsApi } from './api/raciAssignments';
import { testingEnvironmentalSamplingApi } from './api/testingEnvironmentalSampling';
import { pwsWaterMonitoringApi } from './api/pwsWaterMonitoring';
import { reclaimedWaterMonitoringApi } from './api/reclaimedWaterMonitoring';
import { flowMeterLogsApi } from './api/flowMeterLogs';
import { pwsEquipmentServiceLogsApi } from './api/pwsEquipmentServiceLogs';
import { quarterlyDlqorApi } from './api/quarterlyDlqor';
import { annualAnalyticalDataSummaryApi } from './api/annualAnalyticalDataSummary';
import { monthlyReclaimedAnalyticalDataSummaryApi } from './api/monthlyReclaimedAnalyticalDataSummary';
import { constructionPermittingApi } from './api/constructionPermitting';
import { verificationQuestionsApi } from './api/verificationQuestions';
import { auditScopesApi } from './api/auditScopes';
import { enginesApi } from './api/engines';
import { airPermittingApi } from './api/airPermitting';
import { governingBodiesApi } from './api/governingBodies';
import { templatesApi } from './api/templates';
import { standardsAndRegulationsApi } from './api/standardsAndRegulations';
import { auditsApi } from './api/audits';
import { auditLinksApi } from './api/auditLinks';
import { auditAttachmentsApi } from './api/auditAttachments';
import { schedulerMissedRecordsGenerationApi } from './api/schedulerMissedRecordsGeneration';
import { schedulerDebugMethodsApi } from './api/schedulerDebugMethods';
import { customFormsApi } from './api/customForms';
import { fileManagementBlobStorageApi } from './api/fileManagementBlobStorage';
import { emailAndNotificationsApi } from './api/emailAndNotifications';
import { complianceOrderManagementApi } from './api/complianceOrderManagement';
import { sharepointApi } from './api/sharepoint';
import { bugReportsApi } from './api/bugReports';

const apiService = {
  get baseURL() {
    return getBaseUrl();
  },
  set baseURL(value) {
    setBaseUrl(value);
  },
  request,
  productionRequest,
  getHeaders,
};

Object.assign(apiService, authApi, metaSchemaMethodsApi, genericTableOperationsApi, responseEquipmentInventoryApi, transferHoseAndPipeTestingAttachmentsPdfApi, formsStatusesApi, companyModuleManagementApi, r9ModuleApi, complianceEnvironmentalAspectsApi, userManagementApi, healthCheckApi, complianceRecordsApi, customersCompaniesApi, dashboardApi, complianceMapApi, facilitiesSitesApi, raciAssignmentsApi, testingEnvironmentalSamplingApi, pwsWaterMonitoringApi, reclaimedWaterMonitoringApi, flowMeterLogsApi, pwsEquipmentServiceLogsApi, quarterlyDlqorApi, annualAnalyticalDataSummaryApi, monthlyReclaimedAnalyticalDataSummaryApi, constructionPermittingApi, verificationQuestionsApi, auditScopesApi, enginesApi, airPermittingApi, governingBodiesApi, templatesApi, standardsAndRegulationsApi, auditsApi, auditLinksApi, auditAttachmentsApi, schedulerMissedRecordsGenerationApi, schedulerDebugMethodsApi, customFormsApi, fileManagementBlobStorageApi, emailAndNotificationsApi, complianceOrderManagementApi, sharepointApi, bugReportsApi);

export default apiService;
